import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import moment from 'moment-timezone';
import SetupGuide from 'cio/models/setup-guide';
import AnalyticsService from 'cio/services/analytics';
import EnvironmentService from 'cio/services/environment';
import AuthService from 'cio/services/auth';
import FeaturesService from 'ember-feature-flags/services/features';
import RouterService from '@ember/routing/router-service';
import { tracked } from '@glimmer/tracking';
import AccountService from 'cio/services/account';
import ExperimentsService from 'cio/services/experiments';

export default class SetupGuideController extends Controller {
  @service features!: FeaturesService;
  @service auth!: AuthService;
  @service analytics!: AnalyticsService;
  @service environment!: EnvironmentService;
  @service router!: RouterService;
  @service account!: AccountService;
  @service experiments!: ExperimentsService;

  declare model: SetupGuide;

  @tracked isShowingFakeDoorModal = false;

  lastActiveSetupUpGuideStep!: string;

  fakeDoorDemoWorkspaceImage = new URL('cio/assets/images/fake-door-workspace.png', import.meta.url).toString();

  get showFakeDoorBanner() {
    let { id } = this.environment.current;

    if (this.account.current.suspendTrialAt == null) {
      return false;
    }

    if (this.experiments.getExperimentVariation('fakeDoorExperiment') === 'fake_door_control') {
      return false;
    }
    return this.account.current.environments.map((e) => e.id).sort()[0] === id;
  }

  @action
  async finishSetup() {
    this.analytics.track('onboarding', 'setup_finished');

    this.model.set('completedAt', moment().unix());
    await this.model.save();

    this.router.transitionTo('dashboard');
  }

  @action
  showDemoWorkspace() {
    this.isShowingFakeDoorModal = true;
    this.analytics.track('onboarding', 'door_test_clicked', { account_id: this.account.current?.id });
  }

  @action
  trackSubmit(_formValues: Record<string, any>) {
    this.analytics.track('onboarding', 'door_test_form_submitted', { account_id: this.account.current?.id });
  }
}
